// extracted by mini-css-extract-plugin
module.exports = {"handheld":"(max-width: 600px)","footer":"Admin_footer__WSHNE","container":"Admin_container__3Exb6"};